import { useAppSelector } from "@/services/store";
import { contactsIsEditSelector } from "@/pages/ContactsPage/slice";
import { ControlButtons } from "@/pages/ContactsPage/Components/ControlButtons";
import { LeftSectionList } from "../../LeftSectionList";
import { RightSectionList } from "../../RightSectionList";
import { View } from "./Components/View";
import { Edit } from "./Components/Edit";
import styles from "./styles.module.scss";

export const LayoutMobile = () => {
  const isEdit = useAppSelector(contactsIsEditSelector);
  return (
    <>
      {isEdit ? <Edit /> : <View />}
      <div className={styles["section-data-lists"]}>
        <LeftSectionList />
        <RightSectionList />
        {isEdit && <ControlButtons tabType="generalInfo" />}
      </div>
    </>
  );
};
